import React from "react";
import {IProduct} from 'data/interfaces/products';
import {MDBCol, MDBRow} from 'mdbreact';
import {IOrder} from 'data/interfaces/orders';
import {mealTypes} from 'gui/components/editors/hotelEditor/components/hotelDetailsForm/components/offerDetails/components/roomMealSelector';


export interface IPreSaleConclusionProps {
  product?: IProduct;
  order?: IOrder;
}

const SaleDetails = (props: IPreSaleConclusionProps) => (
  <div className="saleDetailsContainer">
    <MDBRow className="type" style={{marginTop: 20, fontSize: "1em"}}>
      <MDBCol className="label" sm="8" style={{fontWeight: 500}}>
        כמות חדרים :
      </MDBCol>
      <MDBCol className="value disableWordBreak"
              sm="4"
              style={{textAlign: 'end'}}>
        {props.product.hotelDetails.roomsAmount}
      </MDBCol>
    </MDBRow>
    <MDBRow className="type" style={{marginTop: 20, fontSize: "1em"}}>
      <MDBCol className="label" sm="8" style={{fontWeight: 500}}>
        כמות אנשים בחדר:
      </MDBCol>
      <MDBCol className="value disableWordBreak"
              sm="4"
              style={{textAlign: 'end'}}>
        {props.product.hotelDetails.roomPeopleAmount}
      </MDBCol>
    </MDBRow>
    <MDBRow className="type" style={{marginTop: 20, fontSize: "1em"}}>
      <MDBCol className="label" sm="4" style={{fontWeight: 500}}>
        סוג ארוחה:
      </MDBCol>
      <MDBCol className="value disableWordBreak"
              sm="8"
              style={{textAlign: 'end'}}>
        {mealTypes.find((mealType) => mealType.value === Math.max(Math.min(props.product.hotelDetails.roomMeal, mealTypes.length - 1), 0)).label}
      </MDBCol>
    </MDBRow>
  </div>
);

SaleDetails.defaultProps = {
  product: {},
};

export default React.memo(SaleDetails);
